// Helpers numéricos, normalización e identificación

export const toNum = (v: unknown, def = 0): number => {
  if (v == null) return def;
  if (typeof v === "number" && Number.isFinite(v)) return v;
  const s = String(v).replace(/\s+/g, "").replace(/\,/g, ".");
  const n = Number(s);
  return Number.isFinite(n) ? n : def;
};

export const r2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;
export const normalizeId = (id: string | number | undefined | null) => (id == null ? "" : String(id));
export const isLogout = () => (window as any).__logoutInProgress === true;

export const mapTipoSolicitante = (t?: "T" | "C" | "O" | "V" | "P" | "F"): "T" | "C" | "O" | "V" | "P" => {
  if (t === "T" || t === "C" || t === "O" || t === "V" || t === "P") return t;
  return "P"; // 'F' (forzar sin combo) => 'P' para API
};
